const dev = {
    baseURL: "http://localhost:7418",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243-sb1.app.netsuite.com',
    aws_bucket: 'magna-sales-portal-uploads',
    uploads_cdn: 'https://dhaqwjp89qvp5.cloudfront.net',
    env: "uat",
};
const uat = {
    baseURL: "http://34.197.161.10:7418",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243-sb1.app.netsuite.com',
    aws_bucket: 'magna-sales-portal-uploads',
    uploads_cdn: 'https://dhaqwjp89qvp5.cloudfront.net',
    env: "uat",
};

const beta = {
    baseURL: "https://beta-api.magnasalespro.com",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243.app.netsuite.com',
    aws_bucket: 'magna-sales-portal-uploads',
    uploads_cdn: 'https://dhaqwjp89qvp5.cloudfront.net',
    env: "beta",
};

const prod = {
    baseURL: "https://prod-api.magnasalespro.com",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243.app.netsuite.com',
    aws_bucket: 'magna-sales-portal-uploads',
    uploads_cdn: 'https://dhaqwjp89qvp5.cloudfront.net',
    env: "prod",
};
module.exports = prod;

